export default "__VITE_ASSET___2yxiQwo__"